<template>
  <section class="advantages-section" id="advantages">
    <div class="advantages-container">
      <div class="section-header">
        <h2 class="section-title">核心优势</h2>
        <div class="title-underline"></div>
      </div>

      <div class="adv-grid">
        <div class="adv-card">
          <div class="adv-icon">高</div>
          <div class="adv-title">高效率</div>
          <div class="adv-desc">快速响应、闭环处理，减少非计划停机时间，让设备尽快恢复产能。</div>
        </div>
        <div class="adv-card">
          <div class="adv-icon">质</div>
          <div class="adv-title">高质量</div>
          <div class="adv-desc">以标准化检测与过程管控为基础，交付可验证、可追溯的服务结果。</div>
        </div>
        <div class="adv-card">
          <div class="adv-icon">技</div>
          <div class="adv-title">专业技术</div>
          <div class="adv-desc">覆盖机械/电气/数控系统等多专业方向，支持精度恢复与系统升级改造。</div>
        </div>
        <div class="adv-card">
          <div class="adv-icon">服</div>
          <div class="adv-title">专业服务</div>
          <div class="adv-desc">维修、保养、托管、检测、搬迁、改造与定制一体化协同，减少沟通成本。</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AdvantagesSection',
};
</script>

<style scoped>
.advantages-section {
  background: #ffffff;
  padding: 80px 0;
}

.advantages-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  margin-bottom: 48px;
}

.section-title {
  font-size: 2rem;
  font-weight: bold;
  color: #1a1a2e;
  margin-bottom: 12px;
  letter-spacing: 1px;
}

.title-underline {
  width: 60px;
  height: 3px;
  background: #1976d2;
  border-radius: 2px;
}

.adv-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.adv-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 22px 18px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.04);
  border: 1px solid #eef2f7;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.adv-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 38px rgba(25, 118, 210, 0.10);
  border-color: #dbeafe;
}

.adv-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(25, 118, 210, 0.12);
  color: #1976d2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  letter-spacing: 2px;
  margin-bottom: 14px;
}

.adv-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.adv-desc {
  color: #54606f;
  line-height: 1.8;
  font-size: 0.95rem;
}

@media (max-width: 1024px) {
  .adv-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .advantages-section {
    padding: 56px 0;
  }
  .adv-grid {
    grid-template-columns: 1fr;
  }
}
</style> 